import {getUserList,getUserListForDealer} from "@/api/User"

export default {
  addUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('ADD_USER', user)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsUser({ commit },payload) {
    return new Promise((resolve, reject) => {
      getUserList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_USERS', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  fetchDataListItemsUserForDealer({ commit },payload) {
    return new Promise((resolve, reject) => {
      getUserListForDealer(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_USERS', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_USER', user)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeUser({ commit }, userId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_USER', userId)
          resolve();
    })
  },
  // eventDragged({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {payload: payload})
  //       .then((response) => {

  //         // Convert Date String to Date Object
  //         let event = response.data
  //         event.startDate = new Date(event.startDate)
  //         event.endDate = new Date(event.endDate)

  //         commit('UPDATE_EVENT', event)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
};